module.exports = __webpack_public_path__ + "img/iomico_logo_text.757ff786.svg";